import { RefObject, useEffect } from 'react';

import { screens } from '../../shared/styles';

const useWidgetScrollLock = (
  isExpanded: boolean,
  containerRef: RefObject<HTMLDivElement>
) => {
  useEffect(() => {
    if (!isExpanded) return;

    const isMobile = window.matchMedia(
      `(max-width: calc(${screens.lg} - 1px))`
    ).matches;
    if (!isMobile) return;

    const scrollY = window.scrollY;
    const html = document.documentElement;
    const originalOverflow = html.style.overflow;
    const originalOverscrollBehavior = html.style.overscrollBehavior;

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';

    return () => {
      html.style.overflow = originalOverflow;
      html.style.overscrollBehavior = originalOverscrollBehavior;
      window.scrollTo(0, scrollY);
    };
  }, [isExpanded, containerRef]);
};

export default useWidgetScrollLock;
